import { alias } from '@ember/object/computed';

import { attr, belongsTo } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  shopType: [
    validator('belongs-to'),
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
  name: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
  pattern: validator('presence', true),
  tradePartner: [
    validator('belongs-to'),
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
});

export const settings = {
  variantProperties: [
    'cmsLanguageId',
    'cmsState',
    'description',
    'pattern',
    'svgUrl',
    'variantChannel',
  ],
};

export default class LinkPatternModel extends Model.extend(Validations) {
  @attr('string') name;
  @attr('string') description;
  @attr('string') pattern;
  @attr('string') svgUrl;

  // Relations
  @belongsTo('trade-partner', { async: true, inverse: null }) tradePartner;
  @belongsTo('category', { async: true, inverse: null }) shopType;

  // Variants
  @belongsTo('channel', { async: true, inverse: null }) variantChannel;

  // CMS fields
  @attr cmsKilldate;
  @attr cmsLivedate;
  @attr('number') position;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter, setter and computed properties
  @alias('name') displayHeadline;
  @alias('name') displayLabel;
}
